<template>
  <div class="middleware"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.ticket = this.$route.query.ticket;
    this.modelId = this.$route.query.lzyProductCode;

    this.userLogin();
  },
  computed: {
    userTicket() {
      return this.$store.state.user?.ticket;
    },
    userToken() {
      return this.$store.state.user?.token;
    }
  },
  methods: {
    decryptTicket() {
      // let res = {
      //   token: "1ab166e099e53808d3ced95cffdefb38",
      //   userId: "1465485171523149826",
      //   userName: "13402007696",
      //   // fixedComponents: "[{\"componentCode\":\"1466369792712773632_T_TextureIndex\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1472432114216255489\"}]},{\"componentCode\":\"1466369792712773632_ColorIndex\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1466381658437005313\"}]}]",
      //   // fixedComponents: '[{\"componentCode\":\"1466376685053153280_02\",\"componentSpecs\":[{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"},{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f5\"}]},{\"componentCode\":\"1466376685053153280_01\",\"componentSpecs\":[{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"},{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"}]},{\"componentCode\":\"1466376685053153280_T_019\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"},{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"}]},{\"componentCode\":\"1466376685053153280_T_018\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"},{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"}]},{\"componentCode\":\"1466376685053153280_T_05\",\"componentSpecs\":[{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"},{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"}]},{\"componentCode\":\"1466376685053153280_T_04\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"},{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"}]},{\"componentCode\":\"1466376685053153280_T_03\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"},{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"}]},{\"componentCode\":\"1466376685053153280_GG3\",\"componentSpecs\":[{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"},{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1a3453e36bc34c9c83114194dd10d8f4\"}]},{\"componentCode\":\"1466376685053153280_04\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1459374380416507907\"},{\"productSpecCode\":\"1\",\"productSpecValueCode\":\"red\"}]}]',
      //   fixedComponents: '[{\"componentCode\":\"1485885114360664064_ColorIndex\",\"componentSpecs\":[{\"productSpecCode\":\"2\",\"productSpecValueCode\":\"1485886207904206851\"}]}]',
      //   productId: "1472432114023317506",
      //   otherComponents: ""
      // };

      // this.$store.commit("SET_USER_INFO", {
      //   lzyProductCode: this.$route.query.lzyProductCode,
      //   cartId: this.$route.query.cartId,
      //   ...res,
      //   ticket: this.$route.query.ticket
      // });
      // this.$emit("complete");
      // return;

      let cartId = this.$route.query.cartId;
      let planId = this.$route.query.planId;
      // 预览方案
      if (planId && !this.ticket) {
        this.$store.commit("SET_USER_INFO", {
          planId,
          lzyProductCode: this.$route.query.lzyProductCode,
          userId: this.$route.query.userId
        });
        this.$emit("complete");
        return;
      }

      //已经加入购物车的预览页面
      if (cartId && !this.ticket) {
        this.$store.commit("SET_USER_INFO", {
          cartId: this.$route.query.cartId
        });
        this.$emit("complete");
        return;
      }

      //正常操作
      let data = this.ticket || "4b5d2e17151fc88db0e39e9fc8d86e91";
      this.$api.shuyang.decryptTicket(data).then(res => {
        const { homePageUrl: indexUrl, shoppingCartUrl: shopingUrl } = res;
        this.$store.commit("SET_USER_INFO", {
          ticket: this.$route.query.ticket,
          cartId: cartId,
          lzyProductCode: this.$route.query.lzyProductCode,
          shopingUrl,
          indexUrl,
          ...res
        });
        this.$emit("complete");

        localStorage.setItem('test', JSON.stringify(res))
      });
    },
    userLogin() {
      let data = {
        username: "admin",
        password: 123456
      };
      this.$api.user.login(data).then(res => {
        localStorage.setItem("token", res.token);
        if (
          this.userToken &&
          this.userTicket &&
          this.userTicket === this.ticket
        ) {
          this.$store.commit("SET_USER_INFO", {
            cartId: this.$route.query.cartId,
            lzyProductCode: this.$route.query.lzyProductCode
          });
          this.$emit("complete");
        } else {
          this.decryptTicket();
        }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.middleware {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: white;
}
</style>  